import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import { getLeadRowData } from 'helpers/leads';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import TableResponsive from 'components/layout/TableResponsive';

class LeadAssign extends React.Component {
  onSelect = lead => {
    this.props.close();

    if (this.props.onSelect) {
      this.props.onSelect(lead);
    }
  };

  render() {
    const { intl, appIntl, show, close, list } = this.props;
    const messages = intl.messages;

    const headers = {
      pipeline: messages.pipeline,
      lead: messages.lead,
      assignee: messages.assignee,
      client: messages.client,
    };
    let rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const lead = list.data.list[i];
      let rowData = getLeadRowData(lead, messages, appIntl, () => this.onSelect(lead));
      delete rowData.actions; // remove actions (edit button)

      rows.push(rowData);
    }

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.assign_lead}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="leads"
            url={'/api/leads.json'}
            list={list}
            sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
          >
            <div class="panel panel-transparent">
              <div class="panel-body no-padding">
                {list.pending ? <Loader /> : <TableResponsive headers={headers} rows={rows} hover />}
              </div>
            </div>
          </List>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.leads,
  };
};

export default injectIntl(connect(mapStateToProps)(LeadAssign));
